import { render } from "./Reference.vue?vue&type=template&id=29e0496e&lang=pug"
import script from "./Reference.vue?vue&type=script&setup=true&lang=js"
export * from "./Reference.vue?vue&type=script&setup=true&lang=js"

import "./Reference.vue?vue&type=style&index=0&id=29e0496e&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__